import Icon from './Icon.jsx'

/*
 * Server-side pagination control — DESIGN.md §7 ("Précédent / Page X / Y / Suivant").
 * Windowed numbered pages (±2) + first/last + ellipses. Only shown by callers
 * when totalPages > 1.
 */
function pageWindow(current, total) {
  const pages = new Set([1, total, current, current - 1, current + 1, current - 2, current + 2])
  const sorted = [...pages].filter((p) => p >= 1 && p <= total).sort((a, b) => a - b)
  const out = []
  let prev = 0
  for (const p of sorted) {
    if (p - prev > 1) out.push('…')
    out.push(p)
    prev = p
  }
  return out
}

const navBtn = (disabled) => ({
  display: 'inline-flex', alignItems: 'center', gap: 6, height: 36, padding: '0 12px',
  borderRadius: 'var(--radius-icon-btn)', border: '1.5px solid var(--color-border-alt)',
  background: '#fff', color: disabled ? 'var(--color-text-muted)' : 'var(--color-text)',
  fontSize: 13, fontWeight: 600, cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.6 : 1,
})

export default function Pagination({ page, totalPages, total, perPage, onPage, onPerPage, unit }) {
  if (totalPages <= 1 && !onPerPage) return null
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, marginTop: 16, flexWrap: 'wrap' }}>
      <div style={{ fontSize: 13, color: 'var(--color-text-muted)' }}>
        {total != null ? `${total}${unit ? ` ${unit}` : ''}` : ''}
        {onPerPage && (
          <>
            {' · '}
            <select
              value={perPage}
              onChange={(e) => onPerPage(Number(e.target.value))}
              aria-label="Par page"
              style={{ height: 32, borderRadius: 8, border: '1.5px solid var(--color-border-strong)', background: '#fff', padding: '0 8px', fontSize: 13, marginLeft: 4 }}
            >
              {[10, 20, 50, 100].map((n) => <option key={n} value={n}>{n} / page</option>)}
            </select>
          </>
        )}
      </div>

      {totalPages > 1 && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <button style={navBtn(page <= 1)} disabled={page <= 1} onClick={() => onPage(page - 1)}>
            <Icon name="chevron-right" size={15} style={{ transform: 'rotate(180deg)' }} /> Précédent
          </button>
          {pageWindow(page, totalPages).map((p, i) => p === '…' ? (
            <span key={`e${i}`} style={{ padding: '0 4px', color: 'var(--color-text-muted)' }}>…</span>
          ) : (
            <button
              key={p}
              onClick={() => onPage(p)}
              aria-current={p === page ? 'page' : undefined}
              style={{
                minWidth: 36, height: 36, borderRadius: 'var(--radius-icon-btn)', fontSize: 13, fontWeight: 600,
                border: '1.5px solid ' + (p === page ? 'var(--color-primary)' : 'var(--color-border-alt)'),
                background: p === page ? 'var(--color-primary)' : '#fff',
                color: p === page ? '#fff' : 'var(--color-text)', cursor: 'pointer',
              }}
            >
              {p}
            </button>
          ))}
          <button style={navBtn(page >= totalPages)} disabled={page >= totalPages} onClick={() => onPage(page + 1)}>
            Suivant <Icon name="chevron-right" size={15} />
          </button>
        </div>
      )}
    </div>
  )
}
